import type { ReactNode } from 'react';

/**
 * SkuIcon — boîte d'icône skeuomorphique.
 *
 * @param color  hex de la couleur thématique (ex: "#0d9488")
 * @param size   taille en px (32 | 36 | 44 | 52)
 *
 * Palette : cyan #0d9488 · indigo #818cf8 · violet #a78bfa
 *           red #ef4444 · green #059669 · amber #f59e0b
 */
export default function SkuIcon({
  children,
  color,
  size = 36,
}: {
  children: ReactNode;
  color: string;
  size?: number;
}) {
  const r = Math.round(size * 0.28);
  return (
    <div
      className="shrink-0 flex items-center justify-center relative overflow-hidden"
      style={{
        width: size,
        height: size,
        borderRadius: r,
        background: `linear-gradient(150deg, ${color}1f 0%, ${color}0a 100%)`,
        border: `1px solid ${color}33`,
        boxShadow: `0 1px 2px rgba(15,23,42,0.06)`,
      }}
    >
      {/* Reflet supérieur */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          borderRadius: r,
          background: 'linear-gradient(180deg,rgba(255,255,255,0.45) 0%,transparent 55%)',
        }}
      />
      {children}
    </div>
  );
}
